'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../../../_virtual/index.cjs');
var InternalButton_web_styles = require('../../internal/InternalButton/InternalButton.web.styles.cjs');
var InternalSkeleton_web = require('../../internal/InternalSkeleton/InternalSkeleton.web.cjs');
var Avatar_web_styles = require('../Avatar/Avatar.web.styles.cjs');
var Skeleton_web_styles = require('./Skeleton.web.styles.cjs');

/**
 * A skeleton component that can be used to show a loading state
 *
 * {@link https://aviary.fullscript.io/latest/components/skeleton/web-FkaKhq3u | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Skeleton/Skeleton.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Skeleton = (props)=>{
    const { isCircular, variant, width: customWidth, height: customHeight, isFullWidth, ...rest } = props;
    const theme = react.useTheme();
    let defaultWidth;
    let defaultHeight;
    switch(variant){
        case "typography":
            {
                const typographyType = props.typographyType || "body";
                defaultWidth = "30%";
                defaultHeight = parseInt(theme.ds5.typography.lineHeight[typographyType]);
                break;
            }
        case "button":
            {
                const buttonSize = InternalButton_web_styles.buttonSkeletonSizes[props.size || "medium"](theme);
                defaultWidth = buttonSize.width;
                defaultHeight = buttonSize.height;
                break;
            }
        case "avatar":
            {
                const avatarSize = Avatar_web_styles.avatarSkeletonSizes[props.size || "medium"];
                defaultWidth = avatarSize.width;
                defaultHeight = avatarSize.height;
                break;
            }
    }
    const width = customWidth ?? defaultWidth;
    const height = customHeight ?? defaultHeight;
    return /*#__PURE__*/ jsxRuntime.jsx(InternalSkeleton_web.InternalSkeleton, {
        width: width,
        height: height,
        borderRadius: index.cjsExports.getBorderRadius(isCircular, variant),
        customStyles: variant === "typography" ? Skeleton_web_styles.typographySkeleton : undefined,
        isFullWidth: isFullWidth,
        ...rest
    });
};

exports.Skeleton = Skeleton;
//# sourceMappingURL=Skeleton.web.cjs.map
